// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switch[data-v-a942ff2e]{display:flex;align-items:center}.switch[data-v-a942ff2e] .v-input{padding:0}.switch[data-v-a942ff2e] .v-input .v-label{color:rgba(0,0,0,.5)}.switch[data-v-a942ff2e] .v-input__control{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
